export const PLACE = 'User Bulk Import';
export const TOOL_NAME = 'Bulk Import Users';

export const STICKY_HEADER_OFFSET = 105;


export const FIELD: {
    EMAIL: string,
    FIRST_NAME: string,
    LAST_NAME: string,
    USER_TYPE: string,
    USER_STATUS: string,
    COUNTRY: string,
    TARGET_ACCOUNT: string,
    PRIOR_ACCOUNT: string,
    GROUP: string,
    JOB_TITLE: string,
    CITY: string,
    NEWSLETTERS: string,
    NOTES: string,
} = {
    EMAIL: 'email',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    USER_TYPE: 'userType',
    USER_STATUS: 'userStatus',
    COUNTRY: 'country',
    TARGET_ACCOUNT: 'targetAccount',
    PRIOR_ACCOUNT: 'priorAccount',
    GROUP: 'group',
    JOB_TITLE: 'jobTitle',
    CITY: 'city',
    NEWSLETTERS: 'newsletters',
    NOTES: 'notes',
};

export const HEADERS = {
    [FIELD.EMAIL]: 'Email',
    [FIELD.FIRST_NAME]: 'First Name',
    [FIELD.LAST_NAME]: 'Last Name',
    [FIELD.USER_TYPE]: 'Type*',
    [FIELD.USER_STATUS]: 'Status*',
    [FIELD.TARGET_ACCOUNT]: 'Target Account*',
    [FIELD.PRIOR_ACCOUNT]: 'Prior Account',
    [FIELD.COUNTRY]: 'Country',
    [FIELD.GROUP]: 'Group',
    [FIELD.JOB_TITLE]: 'Job Title',
    [FIELD.CITY]: 'City',
    [FIELD.NEWSLETTERS]: 'Newsletters',
    [FIELD.NOTES]: 'Notes',
};

export const MATCHING_LIST = [
    {caption: 'Email', required: true},
    {caption: 'First name', required: true},
    {caption: 'Last name', required: true},
    {caption: 'Job Title'},
    {caption: 'Group'},
    {caption: 'Newsletters'},
    {caption: 'Country'},
    {caption: 'City'},
    {caption: 'Notes'},
];
export const UPLOAD_FILE_VALID_EXTENSIONS = ['.csv'];
export const MAX_FILE_SIZE = 100_000_000;
export const UPLOAD_FILE_MAX_SIZE_LIMIT_MB = 250;
export const UPLOAD_BULK_IMPORT_USER_TEMPLATE = '/static/Bulk-import-of-users-template.csv';
export const MAX_RECORD_SIZE = 2000;
export const BROKEN_TEMPLATE_MESSAGE = 'The file does not contain the required columns. Please make sure the file' +
    ' matches the template.';
export const MISSING_HEADER_ROW_MESSAGE = 'File can\'t be parsed. Table doesn\'t have column names.';
export const MISSING_EMAIL_COLUMN_MESSAGE = 'File does not contain Email column. Please make sure the file matches' +
    ' the template';
export const INVALID_FILE_TYPE_MESSAGE = 'Invalid file type. Please upload a CSV file.';

export enum BULK_IMPORT_USERS_STEPS {
    UPLOAD_FILE = 0,
    VALIDATE_FILE = 1,
    CREATION_RESULT = 2,
}

export const STEP_TITLE = {
    [BULK_IMPORT_USERS_STEPS.UPLOAD_FILE]: 'Upload file',
    [BULK_IMPORT_USERS_STEPS.VALIDATE_FILE]: 'Validate file',
    [BULK_IMPORT_USERS_STEPS.CREATION_RESULT]: 'Bulk Import Result',
};
